import axios from "axios";

const API_URL = process.env.VUE_APP_ZHULIA_SELLER_CENTER_URL;
const PRIVATE_KEY = process.env.VUE_APP_ZHULIA_PRIVATE_KEY || "PrivateKey l3Lrk4DcyGidIK8t7zKz5zF6zoL3oh1k";

class SellersService {
  headers = {
    Authorization: PRIVATE_KEY,
  };

  async getAllSellers(params = {}) {
    try {
      const response = await axios.get(
        API_URL + `/ZhuliaAdminSellerAccount/get-paged-seller-account`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            sortColumn: "createdAt",
            sortDir: "desc",
            status: "",
            search: "",
            startDate: "",
            endDate: "",
            ...params,
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSeller(sellerSetupId) {
    try {
      const response = await axios.get(
        API_URL + `/ZhuliaAdminSellerAccount/get-seller-by-id/${sellerSetupId}`,
        { headers: this.headers }
      );

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async approveDocuments(sellerSetupId, approvalType) {
    const payload = {
      sellerId: sellerSetupId,
      approvalStatus: "Approved",
      approvalType: approvalType,
    };

    try {
      const response = await axios.post(
        API_URL + `/ZhuliaAdminSellerAccount/approve-or-reject-kyc`,
        payload,
        { headers: this.headers }
      );

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async rejectDocuments(sellerSetupId, approvalType) {
    const payload = {
      sellerId: sellerSetupId,
      approvalStatus: "Rejected",
      approvalType: approvalType,
    };

    try {
      const response = await axios.post(
        API_URL + `/ZhuliaAdminSellerAccount/approve-or-reject-kyc`,
        payload,
        { headers: this.headers }
      );

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSellerProductsCatalog(sellerSetupId, params = {}) {
    try {
      const response = await axios.get(
        API_URL +
          `/AdminSellerProductCatalog/get-all-seller-product-catalogs/${sellerSetupId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            ...params,
          },
        }
      );

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSellerKeyAccount(sellerSetupId, params) {
    try {
      const response = await axios.get(
        API_URL + `/AdminKeyAccount/get-paged-key-account/${sellerSetupId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            ...params,
          },
        }
      );

      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getProductDetails(sellerProductCatalogId, userSetupId) {
    try {
      const response = await axios.get(
        API_URL +
          `/AdminSellerProductCatalog/get-product-catalog/${sellerProductCatalogId}/${userSetupId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getKeyAccountDetails(accountId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminKeyAccount/get-key-account/${accountId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async createSellerWallet(sellerId) {
    try {
      const response = await axios.post(
        API_URL + `/ZhuliaAdminSellerAccount/create-terra-wallet/${sellerId}`,
        {},
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async createKeyAccountWallet(keyAccountId) {
    try {
      const response = await axios.post(
        API_URL + `/AdminKeyAccount/create-terra-wallet/${keyAccountId}`,
        {},
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async fetchSellerDistributionCenters(sellerId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminSellerProductCatalog/get-seller-distribution-centers/${sellerId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSellerConsignmentOrders(sellerSetupId, params) {
    try {
      const response = await axios.get(
        API_URL +
          `/AdminSellerStockMangement/get-seller-consignment-orders/${sellerSetupId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            excludeDrafts: true,
            ...params,
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async fetchSellerAllocations(sellerSetupId, params) {

    try {
      const response = await axios.get(
        `${API_URL}/AdminSellerStockMangement/get-seller-order-allocations/${sellerSetupId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            ...params,
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSellerConsignmentStats(sellerId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminSellerStockMangement/consignment-stats/${sellerId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getConsignmentDetails(userId, consignmentId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminSellerStockMangement/get-consignment/${userId}/${consignmentId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getBatchDetail(batchOrderId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminSellerStockMangement/get-batch-detail?batchOrderId=${batchOrderId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async updateBatchStatus(payload) {
    try {
      const response = await axios.post(
        API_URL + `/AdminSellerStockMangement/update-batch-status`,
        payload,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async updateAllocationBatchStatus(payload) {
    try {
      const response = await axios.post(
        API_URL + `/AdminSellerStockMangement/receive-order-allocation`,
        payload,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async markAllocationProcessed(payload) {
    try {
      const response = await axios.post(
        API_URL + `/AdminSellerStockMangement/mark-allocation-processed`,
        payload,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async fetchSellerAllocationDetails(sellerId, allocationId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminSellerStockMangement/get-seller-order-allocation/${sellerId}/${allocationId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async getSellerOrders(sellerId, params = {}) {
    try {
      const response = await axios.get(
        API_URL + `/AdminOrderManagement/get-all-seller-orders/${sellerId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            ...params,
          },
        }
      );
      console.log({response})
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSellerInvoices(sellerId, params = {}) {
    try {
      const response = await axios.get(
        API_URL + `/AdminOrderManagement/get-all-seller-invoices/${sellerId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            ...params,
          },
        }
      );
    
      return response;
    } catch (error) {
      return error.response;
    }
  }

  /**
   * Fetch order details by order ID
   */
  async getSellerOrderDetails(orderId) {
    try {
      const response = await axios.get(
        API_URL + `/AdminOrderManagement/get-seller-order-by-id/${orderId}`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  /**
   * Fetch seller account statistics
   */
  async getSellerStats() {
    try {
      const response = await axios.get(
        API_URL + `/ZhuliaAdminSellerAccount/get-seller-account-stats`,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  /**
   * Complete order fulfillment
   */
  async completeOrderFulfillment(orderId) {
    try {
      const response = await axios.post(
        API_URL + `/AdminOrderManagement/order-received/${orderId}`,
        {},
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  /**
   * Fetch factoring applications for a seller with pagination and filters
   */
  async getSellerFactoringApplications(sellerId, params = {}) {
    try {
      const response = await axios.get(
        API_URL + `/AdminOrderManagement/get-all-factoring-applications/${sellerId}`,
        {
          headers: this.headers,
          params: {
            pageIndex: 1,
            pageSize: 10,
            ...params,
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getPagedWallets(params = {}) {
    const defaultParams = {
      pageIndex: 1,
      pageSize: 10,
      sortColumn: "createdAt",
      sortDir: "desc",
      ...params,
    };


    try {
      const response = await axios.get(
        API_URL + `/AdminWallet/get-paged-wallets`,
        { headers: this.headers, params: defaultParams }
      );
      console.log(response);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getSingleWallet(accountUuid) {
    try {
      const response = await axios.get(
        API_URL + `/AdminWallet/get-single-wallet/${accountUuid}`,
        { headers: this.headers }
      );
      console.log('Single Wallet API Response:', response);
      return response;
    } catch (error) {
      console.error('Single Wallet API Error:', error);
      return error.response;
    }
  }

  async updateWalletStatus(terraAccountId, status) {
    try {
      const response = await axios.put(
        API_URL + `/AdminWallet/update-seller-wallet-status`,
        {
          terraAccountId: terraAccountId,
          status: status
        },
        { headers: this.headers }
      );
      console.log('Update Wallet Status API Response:', response);
      return response;
    } catch (error) {
      console.error('Update Wallet Status API Error:', error);
      return error.response;
    }
  }

  async getWalletTransactions(walletUuid, params = {}) {
    try {
      const response = await axios.get(
        API_URL + `/AdminWallet/get-wallet-transactions/${walletUuid}`,
        { headers: this.headers, params: params }
      );
      console.log('Wallet Transactions API Response:', response);
      return response;
    } catch (error) {
      console.error('Wallet Transactions API Error:', error);
      return error.response;
    }
  }

  async getSellerWalletTransactions(sellerId, params = {}) {
    try {
      const response = await axios.get(
        API_URL + `/AdminWallet/get-seller-wallet-transactions/${sellerId}`,
        { headers: this.headers, params: params }
      );
      console.log('Seller Wallet Transactions API Response:', response);
      return response;
    } catch (error) {
      console.error('Seller Wallet Transactions API Error:', error);
      return error.response;
    }
  }

  async uploadMultipleFiles(files) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("Files", file);
    });

    try {
      const response = await axios.post(
        API_URL + `/Files/upload-multiple`,
        formData,
        { headers: this.headers }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  /**
   * Get all factoring applications for a specific seller
   */
  async getAllFactoringApplications(sellerId) {
    
    try {
      const response = await axios.get(
        API_URL + `/AdminOrderManagement/get-all-factoring-applications/${sellerId}`,
        {
          headers: this.headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  /**
   * Approve or reject factoring application
   */
  async approveOrRejectFactoring(payload) {
    try {
      const response = await axios.patch(
        API_URL + `/AdminOrderManagement/approve-or-reject-factoring`,
        payload,
        {
          headers: this.headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export default new SellersService();
